import { authApiHandler } from '../services/authApi'
import type { AuthConfig, Contact } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (): Promise<Contact[] | null> => {
    const provider = cookies.getProvider()
    let idToken = cookies.getIdToken()
    let refreshToken = cookies.getRefreshToken()
    let accessToken = cookies.getAccessToken()
    const isPunchout = provider === 'dustin_punchout'

    const isValidIdToken = token.isValidToken(idToken)
    const selectedContactId = cookies.getContactId()

    if (!isValidIdToken) {
      if (typeof window === 'undefined') {
        return null
      }

      if (!refreshToken) {
        cookies.clearTokens()
        return null
      }

      if (!provider) {
        cookies.clearTokens()
        return null
      }

      const tokens = await authApi.refreshTokens(refreshToken, provider, selectedContactId)

      if (!tokens) {
        cookies.clearTokens()
        return null
      }

      idToken = tokens.idToken
      refreshToken = tokens.refreshToken
      accessToken = tokens.micrositeToken
    }

    const contacts = await authApi.getContacts(idToken, selectedContactId)

    cookies.setIdToken(idToken, isPunchout)
    cookies.setRefreshToken(refreshToken, isPunchout)
    cookies.setAccessToken(accessToken, isPunchout)

    return contacts.map(token.getContact).filter((contact): contact is Contact => contact !== null)
  }
}
